import type { ProgressBucket } from '../types'

const SHORT_MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]

// period_start is a calendar date (YYYY-MM-DD): split it, never parse to an instant.
// Day and week periods read as their (first) day, months as MMM 'YY.
export const formatPeriodLabel = (
  periodStart: string,
  bucket: ProgressBucket
): string => {
  const [year, month, day] = periodStart.split('-').map(Number)
  const monthName = SHORT_MONTHS[month - 1] ?? ''
  if (bucket === 'month') {
    return `${monthName} '${String(year % 100).padStart(2, '0')}`
  }
  return `${monthName} ${day}`
}
